module.exports = "/_next/static/images/ManageUserDeletion@2x-649433beb49a20b0725b82c99718d4c1.png";